import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { DYNAMIC_KEY_STORAGE_TOKENS, TRYNECTAR_URL } from "./constants";
import queryString from "query-string";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Generates an image path based on the provided mode parameter
 * @param {string} basePath - The base path without mode (e.g., '/assets/nectar')
 * @param {string} category - The image category (e.g., 'ethnicity', 'hairstyle')
 * @param {string} filename - The image filename
 * @param {string} mode - The mode ('anime' or 'realistic')
 * @returns {string} - The complete image path
 */
export const getImagePathByMode = (
  basePath,
  category,
  filename,
  mode = "realistic"
) => {
  // Default to realistic if mode is not provided or invalid
  const validMode = mode === "anime" ? "anime" : "realistic";
  return `${basePath}/${validMode}/${category}/${filename}`;
};

/**
 * Updates image URLs in an array of objects based on the mode parameter
 * @param {Array} items - Array of objects containing image URLs
 * @param {string} basePath - The base path for images (e.g., '/assets/nectar')
 * @param {string} category - The image category (e.g., 'ethnicity', 'hairstyle')
 * @param {string} mode - The mode ('anime' or 'realistic')
 * @returns {Array} - Updated array with mode-specific image paths
 */
export const updateImagesBasedOnMode = (
  items,
  basePath,
  category,
  mode = "realistic"
) => {
  if (!items || !Array.isArray(items)) return [];

  // Use a random image from the available ones for each item
  const randomImages = ["girl_1.png", "girl_2.png"];

  return items.map((item) => {
    // Choose a random image from the available ones
    const randomImage =
      randomImages[Math.floor(Math.random() * randomImages.length)];

    return {
      ...item,
      image: getImagePathByMode(basePath, category, randomImage, mode),
    };
  });
};

export const getNectarAuthUrl = (path = "", origin = TRYNECTAR_URL) => {
  const tokens = DYNAMIC_KEY_STORAGE_TOKENS.reduce((acc, key) => {
    const value = localStorage.getItem(key);
    if (!value) {
      console.log("no value for", key);
      return acc;
    }

    acc[key] = value;
    return acc;
  }, {});

  const currentQueryParams = queryString.parse(window.location.search);
  const queryParams = queryString.stringify({
    ...currentQueryParams,
    ...tokens,
  });
  return `${origin}${path}?${queryParams}`;
};

export const getUrl = (url) => {
  const targetUrl = new URL(url, window.location.origin);
  const targetQueryParams = queryString.parse(targetUrl.search);
  const currentQueryParams = queryString.parse(window.location.search);

  const combinedParams = {
    ...targetQueryParams,
    ...currentQueryParams,
  };

  targetUrl.search = queryString.stringify(combinedParams);

  return targetUrl.toString();
};
